import script from "./PacienteDetalleView.vue?vue&type=script&setup=true&lang=js"
export * from "./PacienteDetalleView.vue?vue&type=script&setup=true&lang=js"

import "./PacienteDetalleView.vue?vue&type=style&index=0&id=7dc10042&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7dc10042"]])

export default __exports__